module.exports = __webpack_public_path__ + "img/Weapon_224.24820411.png";